import {lazy} from 'react';
import GenericFallbackSuspense from '../../../ui/GenericFallback/GenericFallbackSuspense';

const FrasersPlusOverlayBody = lazy(() => import('./FrasersPlusOverlayBody'/* webpackChunkName: 'FrasersPlusOverlayBody' */));

export default function FrasersPlusOverlayLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <FrasersPlusOverlayBody />
    </GenericFallbackSuspense>
  );
}
